import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirection1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDirection1"><Path fillRule="evenodd" clipRule="evenodd" d="M11.2501 3H19.3887L22.9181 8L19.3887 13H12.7501V21H11.2501V17H4.61144L1.08203 12L4.61144 7H11.2501V3ZM12.7501 11.5H18.6114L21.082 8L18.6114 4.5H12.7501V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDirection1;
